var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"m-3"},[_vm._v("Cursos Disponibles")]),_c('Card',{attrs:{"courses":_vm.coursesList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }